/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

require('../../normalize-component-d885d5ff.js');
var index = require('../../index-3faf9199.js');
require('../../index-9e1f1547.js');
require('../../vuex.esm-bundler-607ad4c2.js');
require('vue');
require('../../es.number.constructor-17a0e7eb.js');
require('../../to-string-e5a81da9.js');
require('../../themeContent-f8df7540.js');

index.__vue_component__.install = function (Vue) {
  Vue.component(index.__vue_component__.name, index.__vue_component__);
};

module.exports = index.__vue_component__;
